export default [
  {
    title: 'Administração',
    i18n: 'Admin',
    icon: 'SettingsIcon',
    children: [
      {
        title: 'Conteúdo',
        icon: 'FileTextIcon',
        children: [
          {
            title: 'Tipo Relatório',
            i18n: 'ReportType',
            route: 'admin-reportType',
          },
        ],
      },
      {
        title: 'Cadastros base',
        icon: 'SlidersIcon',
        children: [
          {
            title: 'Número Lógico',
            i18n: 'LogicalNumber',
            route: 'admin-logical-number',
          },
        ],
      },
      {
        title: 'Clientes',
        icon: 'UsersIcon',
        children: [
          {
            title: 'Clientes',
            i18n: 'Clients',
            route: 'admin-user-client',
          },
          {
            title: 'Contatos',
            i18n: 'Contact',
            route: 'admin-contact',
          },
        ],
      },
      {
        title: 'Serviços',
        icon: 'GlobeIcon',
        children: [
          {
            title: 'Geolocalização',
            i18n: 'Geolocation',
            route: 'admin-geolocation',
          },
        ],
      },
    ],
  },
]
